import { Box, Tooltip, Typography } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { FS_MD, FS_SM, ICON_SM, ICON_XS } from '../common/theme'

interface TaPassFailProps {
  passCount: number
  failCount: number
}

export default function TaPassFail({ passCount, failCount }: TaPassFailProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {passCount > 0 && (
        <Tooltip title="Passed">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, color: 'success.main' }}>
            <CheckIcon sx={{ fontSize: ICON_SM }} />
            <Typography variant="caption" sx={{ fontSize: FS_MD, fontWeight: 600, lineHeight: 1 }}>
              {passCount}
            </Typography>
          </Box>
        </Tooltip>
      )}
      {failCount > 0 && (
        <Tooltip title="Failed">
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, color: 'error.main' }}>
            <CloseIcon sx={{ fontSize: ICON_SM }} />
            <Typography variant="caption" sx={{ fontSize: FS_MD, fontWeight: 600, lineHeight: 1 }}>
              {failCount}
            </Typography>
          </Box>
        </Tooltip>
      )}
    </Box>
  )
}
